import dicManage from './dic-manage.vue';

var Plugin = {
  install: function install(Vue) {
    Vue.component('dic-manage', dicManage);
  }
};
export { dicManage };
export default Plugin;


//////////////////
// WEBPACK FOOTER
// ./src/component/dic-manage/index.js
// module id = 1
// module chunks = 0